import { HydraHttpClientResponse, fetchHydra as baseFetchHydra } from '@api-platform/admin';

import { getHeaders } from './headers';

export function fetchHydra(url: URL, options = {}): Promise<HydraHttpClientResponse> {
  return baseFetchHydra(url, {
    ...options,
    headers: getHeaders,
  });
}
